/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserReqVo
 */
export interface UpdateUserReqVo {
    /**
     * 用户韩文姓名
     * @type {string}
     * @memberof UpdateUserReqVo
     */
    name?: string;
    /**
     * 用户英文姓名
     * @type {string}
     * @memberof UpdateUserReqVo
     */
    nameEn?: string;
}

/**
 * Check if a given object implements the UpdateUserReqVo interface.
 */
export function instanceOfUpdateUserReqVo(value: object): value is UpdateUserReqVo {
    return true;
}

export function UpdateUserReqVoFromJSON(json: any): UpdateUserReqVo {
    return UpdateUserReqVoFromJSONTyped(json, false);
}

export function UpdateUserReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
    };
}

export function UpdateUserReqVoToJSON(json: any): UpdateUserReqVo {
    return UpdateUserReqVoToJSONTyped(json, false);
}

export function UpdateUserReqVoToJSONTyped(value?: UpdateUserReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'nameEn': value['nameEn'],
    };
}

